import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBagShopping,
  faBars,
  faSearch,
  faShoppingBag,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom";

// logo
import companyLogo from "../../Assets/images/logo.avif";
import config from "../../Config";

const Navbar = () => {
  const [fixedNav, setFixedNav] = useState(false);
  const [searchBar, setSearchBar] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  const [showMobileInnerLink1, setShowMobileInnerLink1] = useState(false);
  const [showMobileInnerLink2, setShowMobileInnerLink2] = useState(false);

  document.addEventListener("scroll", () => {
    if (window.scrollY >= 47) {
      setFixedNav(true);
    } else {
      setFixedNav(false);
    }
  });

  const data = JSON.parse(localStorage.getItem("items"));

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, []);

  return (
    <>
      <header
        className={`bg-white position-relative ${
          fixedNav ? "fixedNavbar" : ""
        }`}
      >
        <div className={`header-text ${fixedNav ? "d-none" : "d-block"}`}>
          <a
            href="https://lawnpride.com.au/products/bow-arrow-500ml-herbicide"
            className="text-white"
          >
            BOW & ARROW - FREE SHIPPING | LIMITED TIME ONLY - CARRIER DISCOUNT
          </a>
        </div>

        <nav className={`container-box navibar`}>
          <div className="menuBtn">
            <FontAwesomeIcon
              icon={faBars}
              className="text-green cross-btn"
              onClick={() => setMobileMenu(true)}
            ></FontAwesomeIcon>
          </div>
          <div className="left-nav">
            <div>
              <a href="https://lawnpride.com.au/">
                <img src={companyLogo} alt="" />
              </a>
            </div>

            <ul className="navlinks  mb-0">
              <li>
                <a href="#">Shop</a>
              </li>
              <li>
                <Link to={`${config.appUrl}`}>Problem Solver</Link>
              </li>
              <li>
                <a href="https://lawnpride.com.au/pages/all-content">
                  Learning Centre
                </a>
                <ul className="dropdown-links">
                  <li>
                    <a href="https://lawnpride.com.au/pages/all-content">
                      All Content
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-weeds">
                      Lawn Weeds
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-pests">
                      Lawn Pests
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-diseases">
                      Lawn Diseases
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-care">
                      Lawn Care
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-fertilising">
                      Lawn Fertilising
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-renovation">
                      Lawn Renovation
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/new-lawns">
                      New Lawns
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-mowing">
                      Lawn Mowing
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/seasonal-lawn-care">
                      Seasonal Lawn Care
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-care-faqs">
                      Lawn Care FAQs
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="https://lawnpride.com.au/pages/programs">
                  Lawn Care Programs
                </a>
                <ul className="dropdown-links">
                  <li>
                    <a href="https://lawnpride.com.au/pages/programs">
                      All Programs
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/blue-couch-lawn-care-program">
                      Blue Couch Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/buffalo-lawn-care-program">
                      Buffalo Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/green-couch-lawn-care-program">
                      Green Couch Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/kikuyu-lawn-care-program">
                      Kikuyu Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/santa-ana-tiftuf-lawn-care-program">
                      Santa Ana Tiftuf Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/zoysia-lawn-care-program">
                      Zoysia Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/zoysia-premium-lawn-care-program">
                      Zoysia Premium Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/cool-season-grass-varieties-lawn-care-program">
                      Cool Season Grass Varieties Program
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="https://lawnpride.com.au/pages/store-locator">
                  Store Locator
                </a>
              </li>
              <li>
                <a href="https://lawnpride.com.au/pages/contact">Contact Us</a>
              </li>
            </ul>

            {/* mobile navbar ------------------ */}
            <ul className={`mobile-navlinks ${mobileMenu ? "showMenu" : ""}`}>
              <div className="mb-4">
                <FontAwesomeIcon
                  icon={faTimes}
                  className="text-light-gray cross-btn"
                  onClick={() => setMobileMenu(false)}
                ></FontAwesomeIcon>
              </div>
              <li>
                <a href="#">Shop</a>
              </li>
              <li>
                <Link
                  to={`${config.appUrl}`}
                  onClick={() => setMobileMenu(false)}
                >
                  Problem Solver
                </Link>
              </li>
              <li>
                <div
                  className="d-flex justify-content-between align-items-center"
                  onClick={() => setShowMobileInnerLink1(!showMobileInnerLink1)}
                >
                  <a>Learning Centre</a>
                  <span className="pe-2">
                    {showMobileInnerLink1 ? "–" : "+"}
                  </span>
                </div>
                <ul
                  className={`mobile-innerLinks ${
                    showMobileInnerLink1 ? "show-inner-links" : ""
                  }`}
                >
                  <li>
                    <a href="https://lawnpride.com.au/pages/all-content">
                      All Content
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-weeds">
                      Lawn Weeds
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-pests">
                      Lawn Pests
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-diseases">
                      Lawn Diseases
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-care">
                      Lawn Care
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-fertilising">
                      Lawn Fertilising
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-renovation">
                      Lawn Renovation
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/new-lawns">
                      New Lawns
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-mowing">
                      Lawn Mowing
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/seasonal-lawn-care">
                      Seasonal Lawn Care
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/lawn-care-faqs">
                      Lawn Care FAQs
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <div
                  className="d-flex justify-content-between align-items-center"
                  onClick={() => setShowMobileInnerLink2(!showMobileInnerLink2)}
                >
                  <a>Lawn Care Programs</a>
                  <span className="pe-2">
                    {showMobileInnerLink2 ? "–" : "+"}
                  </span>
                </div>

                <ul
                  className={`mobile-innerLinks ${
                    showMobileInnerLink2 ? "show-inner-links" : ""
                  }`}
                >
                  <li>
                    <a href="https://lawnpride.com.au/pages/programs">
                      All Programs
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/blue-couch-lawn-care-program">
                      Blue Couch Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/buffalo-lawn-care-program">
                      Buffalo Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/green-couch-lawn-care-program">
                      Green Couch Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/kikuyu-lawn-care-program">
                      Kikuyu Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/santa-ana-tiftuf-lawn-care-program">
                      Santa Ana Tiftuf Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/zoysia-lawn-care-program">
                      Zoysia Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/zoysia-premium-lawn-care-program">
                      Zoysia Premium Program
                    </a>
                  </li>
                  <li>
                    <a href="https://lawnpride.com.au/pages/cool-season-grass-varieties-lawn-care-program">
                      Cool Season Grass Varieties Program
                    </a>
                  </li>
                </ul>
              </li>

              <li>
                <a href="https://lawnpride.com.au/pages/store-locator">
                  Store Locator
                </a>
              </li>
              <li>
                <a href="https://lawnpride.com.au/pages/contact">Contact Us</a>
              </li>
              <li>
                <a href="#">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="me-2 fs-6"
                  ></FontAwesomeIcon>{" "}
                  Account
                </a>
              </li>
            </ul>
            {/* -------------------------------- */}
          </div>

          <div className="navbar-icons">
            <span>
              <a href="https://lawnpride.com.au/account/login?return_url=%2Faccount">
                <FontAwesomeIcon
                  icon={faUser}
                  className="nav-icon user-icon"
                ></FontAwesomeIcon>
              </a>
            </span>
            <span>
              <FontAwesomeIcon
                icon={faSearch}
                className="nav-icon"
                onClick={() => setSearchBar(!searchBar)}
              ></FontAwesomeIcon>
            </span>
            <span className="position-relative">
              <Link
                to={`${config.appUrl}cart`}
                className="nav-icon btn-checkout"
              >
                <FontAwesomeIcon
                  icon={faBagShopping}
                ></FontAwesomeIcon>
                {data?.length >= 1 ? (
                  <span className="badge bg-danger rounded-pill bd-cart-length">
                    {data?.length}
                  </span>
                ) : null}
                <span className="d-md-inline d-none ps-2">Checkout</span>
                {/* </Link> */}
              </Link>
            </span>
          </div>
        </nav>

        <div className={`search-bar ${searchBar ? "search-height" : ""}`}>
          <div className="container-box">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-10 col-9 px-0 position-relative">
                <input
                  type="text"
                  placeholder="Search..."
                  className="search-field"
                />
                <FontAwesomeIcon
                  icon={faSearch}
                  className="nav-icon"
                  id="search-field-icon"
                ></FontAwesomeIcon>
              </div>

              <div className="col-md-2 col-3 text-md-end text-center px-0">
                <FontAwesomeIcon
                  icon={faTimes}
                  className="nav-icon text-light-gray"
                  onClick={() => setSearchBar(false)}
                ></FontAwesomeIcon>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
